import { render } from "./LogOutSvgIcon.vue?vue&type=template&id=2a64a895"
import script from "./LogOutSvgIcon.vue?vue&type=script&lang=js"
export * from "./LogOutSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__